import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Link, Box } from "@mui/material";
import PropTypes from "prop-types";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  perPageOption: {
    fontSize: theme.typography.body2.fontSize,
    marginRight: theme.spacing(2),
    "&:hover": {
      color: theme.palette.primary.main
    }
  },
  activeOption: {
    fontWeight: 700
  }
}));

const PerPageOption = ({ numPerPage, selected, onPerPageChange }) => {
  const classes = useStyles();
  return (
    <Link
      component="button"
      variant="body2"
      color={selected ? "primary" : "textSecondary"}
      underline={selected ? "always" : "none"}
      onClick={() => onPerPageChange(numPerPage)}
      className={clsx(classes.perPageOption, {
        [classes.activeOption]: selected
      })}
    >
      {numPerPage}
    </Link>
  );
};

const PerPageOptions = ({
  numPerPageOptions,
  numItemsPerPage,
  onPerPageChange
}) => {
  return (
    <Box display="flex">
      {numPerPageOptions.map((option, index) => (
        <PerPageOption
          key={index}
          numPerPage={option}
          selected={option === numItemsPerPage}
          onPerPageChange={onPerPageChange}
        />
      ))}
    </Box>
  );
};

export default PerPageOptions;

PerPageOptions.propTypes = {
  /**
   * The function called when the user changes the number of results shown per page
   */
  onPerPageChange: PropTypes.func,
  /**
   * The current number of results shown per page
   */
  numItemsPerPage: PropTypes.string,
  /**
   * The options of how many results to be displayed at a time that the user can select from
   */
  numPerPageOptions: PropTypes.arrayOf(PropTypes.string)
};
